__turbopack_context__.v({
  "grid": "ProspectSources-module__HGwd8q__grid",
  "poolCount": "ProspectSources-module__HGwd8q__poolCount",
  "poolDisabled": "ProspectSources-module__HGwd8q__poolDisabled",
  "poolLabel": "ProspectSources-module__HGwd8q__poolLabel",
  "searching": "ProspectSources-module__HGwd8q__searching",
  "statArrow": "ProspectSources-module__HGwd8q__statArrow",
  "statCell": "ProspectSources-module__HGwd8q__statCell",
  "statClickable": "ProspectSources-module__HGwd8q__statClickable",
  "statLabel": "ProspectSources-module__HGwd8q__statLabel",
  "statValue": "ProspectSources-module__HGwd8q__statValue",
  "stats": "ProspectSources-module__HGwd8q__stats",
});
